import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'




import General from '../../Documentos/Contrato'
import Cancelacion from '../../Documentos/Cancelacion'


import BoxButton from '../../Layout/BoxButton'
import ButtonStrip from '../../Layout/ButtonStrip'


import ModalAddFirmas from '../../ContratoAnual/ModalAddFirmas'





import {
    cancelDocumento,
} from '../../../actions/documentos'


import {
    showHideModalAddFirmas, renewContrato
} from '../../../actions/contratoanual'


import {
    showModalConfirmarAccion
} from '../../../actions/common'




class Contrato extends Component {
	constructor(props) {
		super(props)
		this.state = {
			tabs: [
                { id: 0, caption: 'Documento', component: <General />, estado: 0 },
                { id: 1, caption: 'Cierre', component: <Cancelacion />, estado: 0 },
			],
			selected: 0
		}
    }
    

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }    


    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar este documento?`, () => { this.props.showModalConfirmarAccion(false); this.props.cancelDocumento()})
    } 
    
    

    renew = (result) => {
        if (result == 1)
            this.props.showModalConfirmarAccion(true, `¿Está seguro que desea renovar este contrato?`, () => { this.props.showModalConfirmarAccion(false); this.props.renewContrato(1)})
        else   
            this.props.showModalConfirmarAccion(true, `¿Está seguro que desea no renovar este contrato?`, () => { this.props.showModalConfirmarAccion(false); this.props.renewContrato(0)}) 
    } 


	render() {
		const { tabs, selected } = this.state
        const { documento } = this.props

        if (!documento) return null
        if (!documento.get('solicitude')) return null


        const solicitud = documento.get('solicitude')
        const documentos_solicitud = solicitud.get('documentos')

        const id = documento.get('id')
        const docs_en_espera = documentos_solicitud.filter(x => x.get('id') != id && x.get('tipo') == 5 && x.get('estado') == 13)
        const docs_en_proceso = documentos_solicitud.filter(x => x.get('id') != id && x.get('tipo') == 5 && x.get('estado') > 0 && x.get('estado') < 11)


        let enableBtn = true
        // enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-11-30`) 
        enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-02-03`) 
        enableBtn = enableBtn && docs_en_espera.count() == 0
        enableBtn = enableBtn && documento.get('estado') == 12
        enableBtn = enableBtn && docs_en_proceso.count() == 0

        const boxActions = []

        if (this.state.selected === 0 && enableBtn) {            
            boxActions.push(
                <BoxButton
                key='btn1'
                name="history"
                title="Renovar contrato"
                onClick={ e => this.renew(1) }
                />
            )
        }
        
        
        if (this.state.selected === 0) {            
            boxActions.push(
                <BoxButton
                key='btn2'
                name="cloud-upload"
                title="Cerrar solicitud"
                onClick={ e => this.props.showHideModalAddFirmas(true, solicitud) }
                disabled = { documento.get('estado') != 3 }
                />
            )
        }



        if (this.state.selected === 1 && enableBtn) {            
            boxActions.push(
                <BoxButton
                    key='btn4'
                    id='btn4'
                    name="hand-stop-o"
                    title="No renovar contrato"
                    onClick={ e => this.renew(0) }
                    disabled={documento.get('estado') == 14}
                />
            )
        }        

        if (this.state.selected === 1) {            
            boxActions.push(
                <BoxButton
                key='btn3'
                name="ban"
                title="Cancelar orden/contrato"
                onClick={ e => this.cancel() }
                disabled={ documento.get('estado') == 0 || documento.get('estado') == 14 }
                />
            )
        } 

		return (            
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>

                <div className="col-md-12" style={{ height: '100%' }}>

                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => x.estado <= documento.get('estado')).map(x => {

                                        if (documento.get('estado') >= 3 && documento.get('estado') < 12 && x.id == 1) return null

                                        return (
                                            <li key={ `li02[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                            </li>
                                        )


                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable">
                                { tabs[selected].component }
                            </div>
                        </div>
                    </div> 
                </div>

                <ModalAddFirmas/>

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        cancelDocumento: () => dispatch(cancelDocumento()),
        renewContrato: (result) => dispatch(renewContrato(result)),
        showHideModalAddFirmas: (show, documentos) => dispatch(showHideModalAddFirmas(show, documentos))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contrato)


// WEBPACK FOOTER //
// ./src/components/BusquedaDocumento/Contrato/index.jsx